var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var UserPlus = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M18.0687 13.5H22.5687M20.3187 11.25V15.75M1.3999 19.5C2.38545 18.3254 3.61631 17.3808 5.00596 16.7328C6.39561 16.0848 7.91033 15.7489 9.44365 15.7489C10.977 15.7489 12.4917 16.0848 13.8813 16.7328C15.271 17.3808 16.5019 18.3254 17.4874 19.5M15.0687 10.125C15.0687 13.2316 12.5503 15.75 9.44365 15.75C6.33705 15.75 3.81865 13.2316 3.81865 10.125C3.81865 7.0184 6.33705 4.5 9.44365 4.5C12.5503 4.5 15.0687 7.0184 15.0687 10.125Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
